import { ApiResponse, DataObject, DataPaginate } from "@/types";
import { fetcher, sendData } from "@/services/api/fetcher";
import { useFormMutation } from "@/hooks/useFormMutation";
import { useQuery } from "@tanstack/react-query";
import { CategoryArticle, NewsDetailResponse, NewsResponse } from "./interface";
import { NewsPayload } from "./validation";

// get
const getNews = async (
  query?: string
): Promise<ApiResponse<DataPaginate<NewsResponse>>> => {
  return await fetcher(`article?${query}`);
};

export const useGetNews = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<NewsResponse>>, Error>({
    queryKey: ["useGetNews", query],
    queryFn: () => getNews(query),
  });
};

// get by id
export const getNewsId = async (
  id: number
): Promise<ApiResponse<DataObject<NewsDetailResponse>>> => {
  return await fetcher(`article/${id}`);
};

export const useGetNewsId = (id: number) => {
  return useQuery<ApiResponse<DataObject<NewsDetailResponse>>, Error>({
    queryKey: ["useGetNewsId", id],
    queryFn: () => getNewsId(id),
  });
};

// Mutation
export const useNewsMutation = (
  method: "POST" | "PUT" = "POST",
  id?: number
) => {
  return useFormMutation<
    ApiResponse<DataObject<NewsPayload>>,
    Error,
    NewsPayload
  >({
    mutationFn: async (data): Promise<ApiResponse<DataObject<NewsPayload>>> => {
      const endpoint = id ? `article/${id}` : "article";
      const delay = new Promise((resolve) => setTimeout(resolve, 2000));
      const response: ApiResponse<DataObject<NewsPayload>> = await sendData(
        endpoint,
        data,
        method,
        true
      );
      await delay;
      return response;
    },
    loadingMessage:
      method === "POST" ? "Menyimpan data..." : "Memperbarui data...",
    successMessage:
      method === "POST"
        ? "Data berhasil ditambahkan"
        : "Data berhasil diperbarui",
  });
};

// gett
// get artikel
const getNewsKategori = async (
  query?: string
): Promise<ApiResponse<DataPaginate<CategoryArticle>>> => {
  return await fetcher(`master/category-article?${query}`);
};

export const useGetNewsKategori = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<CategoryArticle>>, Error>({
    queryKey: ["useGetNewsKategori", query],
    queryFn: () => getNewsKategori(query),
  });
};
